export default {
    url: '/main',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'Main',
        role: 'tutorial',
    },
    resolve: {
        steps_names: [
            'tutorial_api',
            function (tutorial_api) {
                return tutorial_api.discribe_main_steps({});
            },
        ],
    },
    controller: [
        '$scope',
        '$location',
        'tutorial_api',
        'chartFilters',
        'steps_names',
        function ($scope, $location, tutorial_api, chartFilters, steps_names) {
            $scope.data = {};
            $scope.steps_names = steps_names;
            $scope.update_retention_table = function (model) {
                tutorial_api.main_tutorial(model).then(function (resp) {
                    $scope.data = resp;
                });
            };
            $scope.apply = function (value) {
                if (value == -1) {
                    return '-';
                } else {
                    return value;
                }
            };
            chartFilters.onChangeChartParams('update_retention_table', $scope.update_retention_table);
            $scope.update_retention_table(chartFilters.get_chart_filters());
        },
    ],
};
